import(/* webpackMode: "eager" */ "/launchappnow/app/global-error.tsx")